// extracted by mini-css-extract-plugin
export default {"addToCartControl":"aca-z","giftCard":"bca-z","btnContainer":"cca-z","cartButton":"dca-z","disabled":"eca-z","stockMessage":"fca-z"};